<template>
  <family-page-wrapper class="family-payment-method">
    <h5 class="page-comment">
      You can use this page to pay your outstanding balance, add credit cards and select default payment method. To add GoGo credits, please
      go to
      <router-link :to="{ path: '/family/ride-credits' }">
        GoGo Credits
      </router-link>
      page.
    </h5>

    <div class="row">
      <div class="col-sm-6 col-12">
        <add-credit-card />
      </div>
      <div class="col-sm-6 col-12">
        <pay-unpaid-rides />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <credit-card-list />
      </div>
    </div>
  </family-page-wrapper>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

const AddCreditCard = defineAsyncComponent(() => import('@/components/UIComponents/Payments/ManuallyAddCreditCard.vue') as any);

const CreditCardList = defineAsyncComponent(() => import('@/components/Main/Operator/Payments/CreditCardList.vue') as any);

const PayUnpaidRides = defineAsyncComponent(() => import('@/components/Main/Operator/Payments/PayUnpaidRides.vue') as any);
</script>
